import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function Testimonials() {
  const testimonials = [{
    name: 'María G.',
    age: 48,
    headline: 'A las 3 semanas dejé de despertarme cansada... y por primera vez sentí que tenía control sobre mi cuerpo.',
    story: 'Me veía exhausta TODO el tiempo. Probé cremas carísimas, fui a la dermatóloga... nada funcionaba. A los 7 días de empezar el método ya dormía mejor. A las 2 semanas mi piel estaba más luminosa. Hoy me siento como en mis 30. No me veo de 30, pero me SIENTO viva de nuevo.'
  }, {
    name: 'Laura M.',
    age: 52,
    headline: 'Mi dermatóloga me preguntó qué estaba haciendo diferente. Le mostré el ebook y lo compró para sus pacientes.',
    story: "Pensé que 'ya era tarde' para sentirme bien. Este ebook me enseñó que el problema no era mi edad, era la inflamación. A los 30 días fui a mi dermatóloga y me dijo: '¿Qué te hiciste? Tu piel está increíble'. Esto es lo que debería enseñarse en todas las consultas."
  }, {
    name: 'Gabriela P.',
    age: 45,
    headline: 'En 2 meses ahorré $85.000 que gastaba en delivery y cremas que no funcionaban.',
    story: "Soy ejecutiva. Mi excusa siempre fue 'no tengo tiempo'. Las recetas de ensaladas en frasco me SALVARON. Preparo todo el domingo en 1 hora. Los productos de piel que recomienda son de farmacia. Ahorré dinero y encima me siento y me veo MEJOR."
  }, {
    name: 'Silvina R.',
    age: 56,
    headline: 'Por primera vez siento que estoy envejeciendo CON dignidad, no EN CONTRA de mi edad.',
    story: "Toda mi vida luché 'contra' mi edad. Tratamientos, botox... una guerra que nunca iba a ganar. Este método me enseñó a OPTIMIZAR mi cuerpo. Dejé de intentar verme de 30 y empecé a enfocarme en SENTIRME bien. Ahora me miro al espejo y me GUSTO."
  }];
  return <Section bg="cream-light" data-id="element-449">
      <div className="text-center mb-20" data-id="element-450">
        <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-451">
          Historias Reales
        </p>
        <h2 className="text-4xl md:text-6xl font-serif text-charcoal mb-6" data-id="element-452">
          Mujeres que ya transformaron su <br className="hidden md:block" data-id="element-453" />
          <span className="italic text-olive" data-id="element-454">forma de envejecer</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-24" data-id="element-455">
        {testimonials.map((t, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="glass-card p-10 md:p-12 rounded-[2rem]" data-id="element-456">
            <div className="flex gap-1 mb-8" data-id="element-457">
              {[...Array(5)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-458" />)}
            </div>

            <h3 className="text-2xl font-serif text-charcoal mb-6 leading-snug" data-id="element-459">
              "{t.headline}"
            </h3>

            <p className="text-charcoal-light font-light leading-relaxed mb-8" data-id="element-460">
              {t.story}
            </p>

            <div className="pt-6 border-t border-gold/20" data-id="element-461">
              <p className="font-medium text-charcoal tracking-wide" data-id="element-462">
                {t.name}
              </p>
              <p className="text-xs uppercase tracking-widest text-olive mt-1" data-id="element-463">
                {t.age} años
              </p>
            </div>
          </motion.div>)}
      </div>

      {/* Stats Banner */}
      <div className="bg-olive-deep text-cream-light rounded-[2.5rem] p-12 max-w-5xl mx-auto shadow-2xl" data-id="element-464">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-white/10" data-id="element-465">
          <div className="text-center px-4" data-id="element-466">
            <p className="text-4xl font-serif text-gold mb-2" data-id="element-467">5.278</p>
            <p className="text-[10px] uppercase tracking-widest opacity-70" data-id="element-468">
              Argentinas
            </p>
          </div>
          <div className="text-center px-4" data-id="element-469">
            <p className="text-4xl font-serif text-gold mb-2" data-id="element-470">94%</p>
            <p className="text-[10px] uppercase tracking-widest opacity-70" data-id="element-471">
              Mejoras en 14 días
            </p>
          </div>
          <div className="text-center px-4" data-id="element-472">
            <p className="text-4xl font-serif text-gold mb-2" data-id="element-473">4.9</p>
            <p className="text-[10px] uppercase tracking-widest opacity-70" data-id="element-474">
              Estrellas
            </p>
          </div>
          <div className="text-center px-4" data-id="element-475">
            <p className="text-4xl font-serif text-gold mb-2" data-id="element-476">89%</p>
            <p className="text-[10px] uppercase tracking-widest opacity-70" data-id="element-477">
              Lo recomienda
            </p>
          </div>
        </div>
      </div>
    </Section>;
}